export interface DateRangePreset {
    /** Button text, e.g. "3M". */
    label: string;
    months: number;
}

export const DATE_RANGE_PRESETS: readonly DateRangePreset[] = [
    { label: '1M', months: 1 },
    { label: '3M', months: 3 },
    { label: '6M', months: 6 },
    { label: '1Y', months: 12 }
];

/** A date as 'YYYY-MM-DD', in UTC. */
export function isoDay(date: Date): string {
    return date.toISOString().slice(0, 10);
}

/**
 * Today minus `months` as 'YYYY-MM-DD', clamped to the end of the target month -
 * plain setMonth() overflows (Aug 31 minus 6 months lands on Mar 3).
 */
export function monthsAgoIso(months: number): string {
    const today = new Date();
    const target = new Date(today);
    // All-UTC, matching isoDay and the server's own bounds - mixing local
    // arithmetic with a UTC serialization shifts the date for UTC+ users.
    target.setUTCDate(1);
    target.setUTCMonth(target.getUTCMonth() - months);
    const lastDay = new Date(
        Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0)
    ).getUTCDate();
    target.setUTCDate(Math.min(today.getUTCDate(), lastDay));
    return isoDay(target);
}
